import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { businessAddressCity },
} = loanFormModel;

export class BusinessAddressCityValidation implements ValidationSchema {
  public name: string = businessAddressCity.name;
  public label: string = businessAddressCity.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: 'City is a required field',
    value: businessAddressCity.required,
  };
  public nullable = true;
}
export default new Validation(new BusinessAddressCityValidation());
